module.exports = require("@swa-ui/shopping/src/FareComparisonSelector/FareComparisonSelector.module.scss");